import { ServiceRequestPayload } from'./types';
import { useSmartMutation } from '@shared/api/queries/hooks';
import { serviceApis } from './api';
import { queryClient } from '@shared/api/queries/queryClient';

export const useCreateBulkServiceRequests = () => {
  return useSmartMutation(
    (data: any): Promise<any> => serviceApis.createBulkServiceRequest(data),
    {
            onSuccess: () => {
                queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
            }
        }
  );
};

export const useCreateSingleServiceRequests = () => {
  return useSmartMutation(
    (data: any): Promise<any> => serviceApis.createSingleServiceRequest(data),
    {
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
        }
    }
  );
};
